var path = 'batch/export/details/exportDetails.tpl.html';
var html = "<react-component name=\"activity-export-details\"/>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;